document.querySelectorAll('.header .b7-language__btn').forEach((btn) => {
  btn.addEventListener('click', function () {
    const b7Language = this.closest('.b7-language-selector')
      .querySelector('.b7-language__box');

    b7Language.classList.toggle('open');
  });
});